<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-spin-clockwise">
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>

<div class="logoutdiv">
  <button class="logout-btn" *ngIf="loginDisplay" (click)="logout()">Logout</button>

  <!-- Hamburger menu -->
  <div class="menu-wrapper" *ngIf="loginDisplay" (click)="$event.stopPropagation()">
    <button class="hamburger-btn" type="button" (click)="$event.stopPropagation(); toggleMenu()">☰</button>

    <!-- Dropdown menu -->

    <div class="menu-dropdown" *ngIf="isMenuOpen">
      <!-- <div class="menu-section">
        <div class="menu-section-title">Source</div>

        <button
          class="menu-item menu-item--primary"
          type="button"
          (click)="$event.stopPropagation(); toggleSource()"
        >
          <span class="menu-item-left">
            <span class="menu-item-title">
              {{ selectedSource === 'cba' ? 'CBA' : 'Scheduling Handbook' }}
            </span>
            <span class="menu-item-subtitle">Click to switch</span>
          </span>

          <span class="menu-item-right">›</span>
        </button>
      </div>

      <div class="menu-divider"></div>

      <div class="menu-row">
        <div class="menu-row-left">
          <div class="menu-row-title">Theme</div>
          <div class="menu-row-subtitle">{{ isDarkMode ? 'Dark' : 'Light' }}</div>
        </div>

        <label class="switch menu-switch" (click)="$event.stopPropagation()">
          <input type="checkbox" (change)="toggleTheme()" [checked]="isDarkMode" />
          <span class="slider"></span>
        </label>
      </div> -->
      <div class="menu-section">
        <div class="menu-section-title">Source</div>

        <button
          class="menu-item menu-item--primary"
          type="button"
          (click)="$event.stopPropagation(); setSource('both')"
        >
          <span class="menu-item-left">
            <span class="menu-item-title">Both</span>
            <span class="menu-item-subtitle">CBA + Scheduling Handbook</span>
          </span>
          <span class="menu-item-right" *ngIf="selectedSource === 'both'">✓</span>
        </button>

        <button
          class="menu-item menu-item--primary"
          type="button"
          (click)="$event.stopPropagation(); setSource('cba')"
        >
          <span class="menu-item-left">
            <span class="menu-item-title">CBA</span>
            <span class="menu-item-subtitle">Contract only</span>
          </span>
          <span class="menu-item-right" *ngIf="selectedSource === 'cba'">✓</span>
        </button>

        <button
          class="menu-item menu-item--primary"
          type="button"
          (click)="$event.stopPropagation(); setSource('handbook')"
        >
          <span class="menu-item-left">
            <span class="menu-item-title">Scheduling Handbook</span>
            <span class="menu-item-subtitle">Handbook only</span>
          </span>
          <span class="menu-item-right" *ngIf="selectedSource === 'handbook'">✓</span>
        </button>
      </div>
      <div class="menu-divider"></div>

        <div class="menu-row">
          <div class="menu-row-left">
            <div class="menu-row-title">Theme</div>
            <div class="menu-row-subtitle">{{ isDarkMode ? 'Dark' : 'Light' }}</div>
          </div>

          <label class="switch menu-switch" (click)="$event.stopPropagation()">
            <input type="checkbox" (change)="toggleTheme()" [checked]="isDarkMode" />
            <span class="slider"></span>
          </label>
        </div>
    </div>
  </div>

  <img
    [src]="isDarkMode ? '../assets/SWAPA_Core_RGB_Wht_transp.png' : '../assets/SWAPA_Core_RGB_Blue_transp.png'"
    alt="Contract AI Logo"
    class="logo">
</div>

<div class="app-container">
  <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
  <router-outlet *ngIf="!isIframe"></router-outlet>
</div>
